// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalOverlayFavorite {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.modalContentFavorite {
  width: 418px;
  background-color: #ffffff;
  position: relative;
}

p.titleModalFavorite {
  font-weight: 500;
  font-size: 20px;
}

.headerModalFavorite {
  display: flex;
  justify-content: space-between;
  margin: 0px 20px 0px 20px;
  padding-top: 35px;
}

.bodyModalFavorite {
  display: flex;
  margin: 0px 20px 45px 20px;
  flex-direction: column;
  align-items: center;
}

.buttonFavorite {
  width: 317.5px;
  margin-top: 35px;
  padding-bottom: 50px;
  cursor: pointer;
}

.closeButton {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/componentes/modalFavorite/modalFavoirte.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB","sourcesContent":[".modalOverlayFavorite {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 99999;\n}\n\n.modalContentFavorite {\n  width: 418px;\n  background-color: #ffffff;\n  position: relative;\n}\n\np.titleModalFavorite {\n  font-weight: 500;\n  font-size: 20px;\n}\n\n.headerModalFavorite {\n  display: flex;\n  justify-content: space-between;\n  margin: 0px 20px 0px 20px;\n  padding-top: 35px;\n}\n\n.bodyModalFavorite {\n  display: flex;\n  margin: 0px 20px 45px 20px;\n  flex-direction: column;\n  align-items: center;\n}\n\n.buttonFavorite {\n  width: 317.5px;\n  margin-top: 35px;\n  padding-bottom: 50px;\n  cursor: pointer;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
